(function () {
  var root = document.querySelector('[data-rcut]');
  if (!root) return;

  var labelEl = root.querySelector('[data-rcut-label]');
  var daysBoxEl = root.querySelector('[data-rcut-days-box]');
  var daysEl = root.querySelector('[data-rcut-days]');
  var daysUnitEl = root.querySelector('[data-rcut-days-unit]');
  var hrsBoxEl = root.querySelector('[data-rcut-hrs-box]');
  var hrsEl = root.querySelector('[data-rcut-hrs]');
  var minsBoxEl = root.querySelector('[data-rcut-mins-box]');
  var minsEl = root.querySelector('[data-rcut-mins]');
  var secsEl = root.querySelector('[data-rcut-secs]');

  var CUTOFF_WEEKDAYS = [3, 6]; // Wednesday, Saturday

  function nextCutoff(now) {
    var candidates = CUTOFF_WEEKDAYS.map(function (weekday) {
      var d = new Date(now.getTime());
      var diff = (weekday - d.getDay() + 7) % 7;
      d.setDate(d.getDate() + diff);
      d.setHours(23, 59, 59, 999);
      if (d.getTime() <= now.getTime()) {
        d.setDate(d.getDate() + 7);
      }
      return d;
    });
    candidates.sort(function (a, b) { return a.getTime() - b.getTime(); });
    return candidates[0];
  }

  function deliveryDayFor(cutoff) {
    return cutoff.getDay() === 3 ? 'Sunday' : 'Wednesday';
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var now = new Date();
    var cutoff = nextCutoff(now);
    var remaining = cutoff.getTime() - now.getTime();
    if (remaining < 0) remaining = 0;
    var deliveryDay = deliveryDayFor(cutoff);

    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    if (labelEl) labelEl.innerHTML = 'Time left to order for delivery this <strong>' + deliveryDay + '</strong>:';
    if (daysBoxEl) daysBoxEl.hidden = days <= 0;
    if (daysEl) daysEl.textContent = pad(days);
    if (daysUnitEl) daysUnitEl.textContent = days === 1 ? 'Day' : 'Days';
    if (hrsBoxEl) hrsBoxEl.hidden = hours <= 0;
    if (hrsEl) hrsEl.textContent = pad(hours);
    if (minsBoxEl) minsBoxEl.hidden = minutes <= 0;
    if (minsEl) minsEl.textContent = pad(minutes);
    if (secsEl) secsEl.textContent = pad(seconds);
  }

  tick();
  setInterval(tick, 1000);
})();
